'use client';

import { c as _c } from "react/compiler-runtime";
import dynamic from 'next/dynamic';
import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';
import { parseEmbedPins } from '../../components/cesium/parseEmbedPins';
import AppLayout from '../../layouts/AppLayout/AppLayout';

// Set CESIUM_BASE_URL globally before Cesium is loaded
if (typeof window !== 'undefined') {
  window.CESIUM_BASE_URL = '/cesium/';
}
const MapView = dynamic(() => import('../../components/cesium/MapView'), {
  ssr: false
});
type Mode = 'full' | 'compact' | 'embed';
function readMode(value: string | null): Mode {
  if (value === 'compact') return 'compact';
  if (value === 'embed') return 'embed';
  return 'full';
}
export default function MapPage() {
  const $ = _c(4);
  const searchParams = useSearchParams();
  const mode = readMode(searchParams?.get("mode") ?? null);
  if (mode === "embed") {
    let t0;
    if ($[0] !== searchParams) {
      t0 = <MapEmbed searchParams={searchParams} />;
      $[0] = searchParams;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  if (mode === "compact") {
    let t0;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <div className="relative size-full"><MapView initialMode="minimap" flush={true} hideExpand={true} /></div>;
      $[2] = t0;
    } else {
      t0 = $[2];
    }
    return t0;
  }
  let t0;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <AppLayout fullWidth={true}><div className="relative size-full"><MapView /></div></AppLayout>;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
}
function MapEmbed(t0) {
  const $ = _c(13);
  const {
    searchParams
  } = t0;
  let t1;
  if ($[0] !== searchParams) {
    t1 = parseEmbedPins(searchParams);
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const pins = t1;
  let t2;
  if ($[2] !== searchParams) {
    t2 = searchParams?.get("hideExpand");
    $[2] = searchParams;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const hideExpand = t2 === "1";
  let t3;
  if ($[4] !== searchParams) {
    t3 = searchParams?.get("hideClose");
    $[4] = searchParams;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const hideClose = t3 === "1";
  const [focusedPin, setFocusedPin] = useState(null);
  let t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      const onMessage = e => {
        const data = e.data;
        if (data && typeof data === "object" && (data as {
          type?: unknown;
        }).type === "FLY_TO" && typeof (data as {
          latitude?: unknown;
        }).latitude === "number" && typeof (data as {
          longitude?: unknown;
        }).longitude === "number") {
          setFocusedPin({
            latitude: (data as {
              latitude: number;
            }).latitude,
            longitude: (data as {
              longitude: number;
            }).longitude
          });
        }
      };
      window.addEventListener("message", onMessage);
      return () => window.removeEventListener("message", onMessage);
    };
    t5 = [];
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useEffect(t4, t5);
  let t6;
  if ($[8] !== focusedPin || $[9] !== hideClose || $[10] !== hideExpand || $[11] !== pins) {
    t6 = <div className="h-screen w-screen"><MapView pins={pins} focusedPin={focusedPin} initialMode="minimap" height="100%" hideExpand={hideExpand} hideClose={hideClose} flush={true} /></div>;
    $[8] = focusedPin;
    $[9] = hideClose;
    $[10] = hideExpand;
    $[11] = pins;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}